import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/accesscontrol.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/automatedreporting.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/crossplatform.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/dataaccess.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/humancentric.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/scripting.svg");
;
import(/* webpackMode: "eager" */ "/app/public/ourservice/datavisualization/statistics.svg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/Component/DataCollectionMobileCarousel/index.tsx");
